<template>
  <div class="container dgs reliable grid-gua paper-grain" data-product="reliable">
      <div class="rl-head">
        <div class="seal">靠</div>
        <h1 class="page-title">靠谱吗</h1>
        <div class="sub">匹配记录 · 两人合盘</div>
      </div>
       <div class="record-list">
         <div v-for="(item,index) in recordList" :key="index" class="record-item row-item">
             <div class="thumb serif">{{index + 1}}</div>
             <div class="meta" @click="gotoResult(item.id)">
                <div class="t">{{item.name}} · {{item.sex}}</div>
                <div class="d">{{item.birthday}}</div>
             </div>
             <em class="go" @click="gotoResult(item.id)">详</em>
             <i @click="deleteReport(item.id)" class="el-icon-delete del"></i>
         </div>
       </div>
       <div class="foot">两个人·一张合盘</div>
  </div>
</template>
<script>
import axios from 'axios'
import { areaList } from '@vant/area-data';
import { Toast } from 'vant';
import { Dialog } from 'vant';
import {postAction} from '@/api/manage'
export default {
  name: 'success',
  data() {
    return {
     recordList:1,
   };
  },
  computed:{
    userinfoLove() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.$store.getters.getUserinfoLove || {};
    },
    openid() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.userinfoLove.jsopenid;
    },
    unionid() {
      // 通过vuex的getters方法来获取state里面的数据
        return this.userinfoLove.unionid;
    },
    headimg() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.userinfoLove.image;
    },
    name() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.userinfoLove.nickname;
    },
  },
  mounted(){
    this.getList()
  },
  methods:{
    gotoResult(id){
      this.$router.push({path:'/reliableResult',query:{id:id}})
    },
    getList(){
        const url = '/xcxlove/double/list'
        postAction(url, {unionid:this.unionid}).then(res => {
          if (res.data.code == 200) {
              this.recordList = res.data.msg
              this.recordList.forEach(item => {
                 const birthdaylist = item.birthday.split('-')
                 item.birthday = birthdaylist[0]+'年'+birthdaylist[1]+'月'+birthdaylist[2]+'日'
              })
          }
        })
    },
    deleteReport(id){
        var that = this
        Dialog.alert({
          title: '提示',
          message: '此操作将删除该条数据, 是否继续?',
        }).then(() => {
          const url = '/xcxlove/del'
          postAction(url, {Id:id}).then(res => {
            Toast.success('删除成功');
            that.getList()
          })
        });
    }
  }
}
</script>
<style scoped>
@import "../style/design-system.css";

.container{
    width: 100%;
    max-width: 440px;
    margin: 0 auto;
    min-height: 100vh;
    background: var(--paper);
    box-sizing: border-box;
}

/* 版头 */
.rl-head { text-align: center; padding: 8px 0 4px; }
.rl-head .seal { width: 56px; height: 56px; font-size: 24px; margin-bottom: 14px; }
.rl-head .page-title { font-family: var(--f-serif); font-size: 28px; letter-spacing: .16em; color: var(--ink); margin: 0; }
.rl-head .sub { margin-top: 8px; font-size: 13px; color: var(--ink-mute); letter-spacing: .08em; }

/* 记录列表 */
.record-list { padding: 22px 16px 0; display: flex; flex-direction: column; gap: 12px; }
.record-item.row-item {
  flex-wrap: wrap;
  cursor: pointer;
}
.record-item .thumb {
  width: 40px; height: 40px; border-radius: 10px; flex: none;
  background: linear-gradient(135deg, var(--seal-soft), var(--seal-soft));
  color: var(--seal-dk); font-size: 18px;
}
.record-item .meta { flex: 1; min-width: 0; cursor: pointer; }
.record-item .meta .t { font-size: 15px; font-weight: 600; color: var(--ink); }
.record-item .meta .d { font-size: 12px; color: var(--ink-mute); margin-top: 4px; }
.record-item .go { font-style: normal; font-family: var(--f-serif); color: var(--seal); font-size: 15px; flex: none; }
.record-item .del { color: var(--ink-faint); flex: none; }

.foot { margin-top: 30px; text-align: center; color: var(--ink-mute); font-size: 12px; letter-spacing: .08em; }
</style>